import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    $(document).ready(function () {
        var selector = "#hero";

        if ($(selector).length) {
            if (log) console.log("%ccustom_chapter-title.js initialized", "color: green;");
            gsap.registerPlugin(ScrollTrigger);

            var $instance = $(selector);
            var $images = $instance.find("img");
            var total = $images.length;
            var loaded = 0;

            $images.each(function () {
                $(this).one("load", function () {
                    loaded++;
                    if (loaded === total) {
                        setTimeout(function () {
                            $images.addClass("on").on("transitionend", function () {
                                $instance
                                    .find(".overlay-wrapper")
                                    .addClass("on")
                                    .on("transitionend", function () {
                                        $instance.find(".slide-up").addClass("on");
                                        $("html").addClass("intro-finished");
                                    });
                            });
                        }, 500);
                    }
                });
            });
        }
    });
})();
